import { useState } from "react";
import { Button } from "../ui/button";
import { XIcon } from "lucide-react";
import { SystemAnnouncement } from "@/helpers/userContext";

interface AnnouncementBannerProps {
  announcements: SystemAnnouncement[];
}

const AnnouncementBanner: React.FC<AnnouncementBannerProps> = ({
  announcements,
}) => {
  const [hiddenAnnouncements, setHiddenAnnouncements] = useState<Set<string>>(
    new Set(),
  );

  const visibleAnnouncements = announcements.filter(
    (announcement) => !hiddenAnnouncements.has(announcement.id),
  );

  if (visibleAnnouncements.length === 0) return null;

  const hideAnnouncement = (announcementId: string) => {
    setHiddenAnnouncements((prev) => {
      const newSet = new Set(prev);
      newSet.add(announcementId);
      return newSet;
    });
  };

  return (
    <div className="bg-link text-black">
      {visibleAnnouncements.map((announcement) => (
        <div
          key={announcement.id}
          className="h-12 flex items-center p-3 text-xs justify-between border-b border-primary gap-2"
        >
          <p dangerouslySetInnerHTML={{ __html: announcement.message }} />
          <Button
            className="bg-transparent h-full w-min hover:bg-transparent shadow-none"
            onClick={() => hideAnnouncement(announcement.id)}
          >
            <XIcon className="w-5 h-5 text-black" />
          </Button>
        </div>
      ))}
    </div>
  );
};

export default AnnouncementBanner;
